<mat-card>
  <mat-card-title>{{ title() }}</mat-card-title>
  <mat-card-content>

    <mat-tab-group>
      <mat-tab label="Normalized">
        @if (!normalizedImageError()) {
          <img [src]="normalizedUrl()" alt="Source Image" (error)="normalizedImageError.set(true)"/>
        } @else {
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>

        }
      </mat-tab>
      <mat-tab label="Not Normalized">
        @if (!nonNormalizedImageError()) {
          <img [src]="nonNormalizedUrl()" alt="Source Image" (error)="nonNormalizedImageError.set(true)"/>
        } @else {
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        }
      </mat-tab>
    </mat-tab-group>

  </mat-card-content>

</mat-card>

<ng-template #noDataTemplate>
  <div class="no-data-placeholder">
    <p>No resiliency curve available for this county.</p>
  </div>
</ng-template>
